import { createContext, useContext } from "react";
import { PositionedMarker } from "../../types/marker";

export type MarkersState = {
  markers: PositionedMarker[];
  prevMarker?: PositionedMarker;
  nextMarker?: PositionedMarker;
};

export const MarkersContext = createContext<MarkersState | undefined>(
  undefined
);

export const useMarkers = () => {
  const state = useContext(MarkersContext);

  if (state === undefined) {
    throw new Error(
      "useMarkers must be used within a MarkersProvider provider."
    );
  }

  return state;
};
